/**
 * Copyright (c) 2023 Google LLC
 * SPDX-License-Identifier: MIT
 */

import { csCZ } from './resources/cs-CZ';
import { daDK } from './resources/da-DK';
import { deDE } from './resources/de-DE';
import { en } from './resources/en';
import { esES } from './resources/es-ES';
import { fiFI } from './resources/fi-FI';
import { frCA } from './resources/fr-CA';
import { frFR } from './resources/fr-FR';
import { heIL } from './resources/he-IL';
import { hiIN } from './resources/hi-IN';
import { itIT } from './resources/it-IT';
import { jaJP } from './resources/ja-JP';
import { koKR } from './resources/ko-KR';
import { ltLT } from './resources/lt-LT';
import { nbNO } from './resources/nb-NO';
import { nlNL } from './resources/nl-NL';
import { plPL } from './resources/pl-PL';
import { ptBR } from './resources/pt-BR';
import { ptPT } from './resources/pt-PT';
import { ruRU } from './resources/ru-RU';
import { svSE } from './resources/sv-SE';
import { thTH } from './resources/th-TH';
import { trTR } from './resources/tr-TR';
import { ukUA } from './resources/uk-UA';
import { zhCN } from './resources/zh-CN';
import { zhTW } from './resources/zh-TW';

export const i18nResources = Object.assign(
  {},
  csCZ.resources,
  daDK.resources,
  deDE.resources,
  en.resources,
  esES.resources,
  fiFI.resources,
  frCA.resources,
  frFR.resources,
  heIL.resources,
  hiIN.resources,
  itIT.resources,
  jaJP.resources,
  koKR.resources,
  ltLT.resources,
  nbNO.resources,
  nlNL.resources,
  plPL.resources,
  ptBR.resources,
  ptPT.resources,
  ruRU.resources,
  svSE.resources,
  thTH.resources,
  trTR.resources,
  ukUA.resources,
  zhCN.resources,
  zhTW.resources
);
